import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

const iconPath = `M9.99,23c-0.43,0-0.81-0.27-0.95-0.69L6.3,14L2,14c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h0L7.02,12
	c0.43,0,0.81,0.28,0.95,0.69l1.78,5.4L13,1.8c0.09-0.44,0.47-0.77,0.92-0.8c0.45-0.03,0.87,0.25,1.01,0.68l2.8,8.32H22
	c0.55,0,1,0.45,1,1s-0.45,1-1,1h-4.99c-0.43,0-0.81-0.27-0.95-0.68l-1.83-5.45L10.96,22.2c-0.09,0.44-0.47,0.77-0.92,0.8
	C10.03,23,10.01,23,9.99,23z`

/**
 * Stateless component representing a analysis icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AnalysisIcon width={12} />
 */
const AnalysisIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

AnalysisIcon.defaultProps = defaultProps

export { AnalysisIcon }
